// extracted by mini-css-extract-plugin
export default {"wrapper":"XIbQ0yiDQHkYgbtNUuaQ","titleContainer":"qS4Ie7BC4CF6aN89V78t"};